import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(ElementUI)

import VueAwesomeSwiper from 'vue-awesome-swiper';
import 'swiper/swiper-bundle.css';

Vue.use(VueAwesomeSwiper)

Vue.config.productionTip = false

function rems() {
  function setRem() {
    let rootElement = document.documentElement;
    let rootElementWidth = rootElement.getBoundingClientRect().width;
    const minWidth = 19;  // 最小宽度，可根据需求调整
    const maxWidth = 1900; // 最大宽度，可根据需求调整\
    if (rootElementWidth < minWidth) {
      rootElementWidth = minWidth;
    } else if (rootElementWidth > maxWidth) {
      rootElementWidth = maxWidth;
    }
    let rem = rootElementWidth / 19;
    rootElement.style.fontSize = rem + "px";
  }
  setRem();
  let timer;
  window.addEventListener("resize", function () {
    timer && clearTimeout(timer);
    timer = setTimeout(setRem, 10);
  }, false);
}
rems()

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
